import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import Graph, { GraphProps } from 'components/Flux/Automatic/Monthly/Graph';
import { cssVar } from 'constants/theme';

import './index.scss';

// Mesmo padrão de tela cheia usado em Meteorology (ex.: Fields/TrackingForecast/DetailedView/
// Mobile/FullscreenChart): overlay fixo, girado para paisagem, para caber os dois dataZoom
// (eixo X e Y) que deixam o gráfico ilegível no card estreito do mobile.
export default function FullscreenChart({
  open,
  dismiss,
  data,
  formatString,
}: {
  open: boolean;
  dismiss: () => void;
  data: GraphProps['data'];
  formatString?: GraphProps['formatString'];
}) {
  if (!open) return null;

  return (
    <div className="flux-automatic-monthly-fullscreen-overlay">
      <button
        type="button"
        aria-label="Sair do modo tela cheia"
        className="flux-automatic-monthly-fullscreen-close"
        onClick={dismiss}
      >
        <Icon iconType="close" color={cssVar('text-strong')} />
      </button>
      <div className="flux-automatic-monthly-fullscreen-rotate">
        <div className="flux-automatic-monthly-fullscreen-chart">
          <Graph data={data} formatString={formatString} height="100%" />
        </div>
      </div>
      <span className="flux-automatic-monthly-fullscreen-caption">
        Modo paisagem · toque no X para sair
      </span>
    </div>
  );
}
